export const legal = {
  // Cookie Banner
  'legal.cookies.title': 'We use cookies and local storage',
  'legal.cookies.description': 'We use essential cookies for authentication and preferences. Optionally, we use Sentry for error tracking to help us improve the platform. You can customize your preferences.',
  'legal.cookies.learnMore': 'Learn more',
  'legal.cookies.acceptAll': 'Accept all',
  'legal.cookies.rejectOptional': 'Essential only',
  'legal.cookies.customize': 'Customize',
  'legal.cookies.showDetails': 'Show Details',
  'legal.cookies.hideDetails': 'Hide Details',
  
  // Privacy links
  'legal.privacy': 'Privacy Policy',
  'legal.cookies': 'Cookie Policy',
  
  // Navigation  
  'legal.backToHome': 'Back to Home',
  'legal.lastUpdated': 'Last updated',
  'legal.nav.privacy': 'Privacy Policy',
  'legal.nav.terms': 'Terms of Service',
  'legal.nav.cookies': 'Cookie Policy',
  
  // Contact page
  'legal.contact.pageTitle': 'Contact Us',
  'legal.contact.metaDescription': 'Get in touch with our team for support, questions, or feedback',
  'legal.contact.title': 'Contact Us',
  'legal.contact.subtitle': 'We\'re here to help. Reach out to us for any questions or support.',
  'legal.contact.general.title': 'General Contact',
  'legal.contact.general.description': 'For general inquiries and support',
  'legal.contact.phone.hours': 'Monday-Friday, 9 AM - 6 PM CET',
  'legal.contact.specialized.title': 'Specialized Support',
  'legal.contact.dpo': 'Data Protection Officer',
  'legal.contact.support': 'Customer Support',
  'legal.contact.technical': 'Technical Support',
  'legal.contact.response.title': 'Response Times',
  'legal.contact.response.general': 'General inquiries:',
  'legal.contact.response.generalTime': '24-48 hours',
  'legal.contact.response.technical': 'Technical support:',
  'legal.contact.response.technicalTime': '2-4 hours',
  'legal.contact.response.privacy': 'Privacy requests:',
  'legal.contact.response.privacyTime': '72 hours',
  'legal.contact.response.urgent': 'Urgent matters:',
  'legal.contact.response.urgentTime': '1-2 hours',
  'legal.contact.form.title': 'Send us a message',
  'legal.contact.form.name': 'Name',
  'legal.contact.form.namePlaceholder': 'Your name',
  'legal.contact.form.email': 'Email',
  'legal.contact.form.emailPlaceholder': 'your.email@example.com',
  'legal.contact.form.category': 'Category',
  'legal.contact.form.categoryPlaceholder': 'Select a category',
  'legal.contact.form.categories.general': 'General',
  'legal.contact.form.categories.technical': 'Technical Support',
  'legal.contact.form.categories.privacy': 'Privacy',
  'legal.contact.form.categories.billing': 'Billing',
  'legal.contact.form.categories.feedback': 'Feedback',
  'legal.contact.form.subject': 'Subject',
  'legal.contact.form.subjectPlaceholder': 'Brief description of your inquiry',
  'legal.contact.form.message': 'Message',
  'legal.contact.form.messagePlaceholder': 'Please provide details about your inquiry...',
  'legal.contact.form.sending': 'Sending...',
  'legal.contact.form.send': 'Send Message',
  'legal.contact.form.disclaimer': 'We\'ll respond to your inquiry within our standard response times listed above.',
  'legal.contact.form.success': 'Message sent successfully!',
  'legal.contact.form.error': 'Failed to send message. Please try again.',
  
  // Cookies page
  'legal.cookies.pageTitle': 'Cookie Policy',
  'legal.cookies.metaDescription': 'Learn about how we use cookies and manage your cookie preferences',
  'legal.cookies.preferences.title': 'Cookie Preferences',
  'legal.cookies.preferences.description': 'Manage your cookie settings below',
  'legal.cookies.rejectAll': 'Reject All',
  'legal.cookies.what.title': 'What data do we store?',
  'legal.cookies.what.description': 'We use a combination of cookies (for authentication) and browser local storage (for preferences). Cookies are small text files stored on your device. We do not use any marketing or advertising cookies.',
  'legal.cookies.categories.title': 'Cookie Categories',
  'legal.cookies.categories.essential.title': 'Essential Cookies',
  'legal.cookies.categories.essential.description': 'Required for authentication, preferences, and security. Cannot be disabled.',
  'legal.cookies.categories.errorTracking.title': 'Error Tracking (Optional)',
  'legal.cookies.categories.errorTracking.description': 'Helps us identify and fix bugs using Sentry. All data is anonymized.',
  'legal.cookies.yourChoices.title': 'Your Choices',
  'legal.cookies.manage.title': 'Managing Cookies',
  'legal.cookies.changes.title': 'Changes to This Policy',
  
  // Privacy page
  'legal.privacy.pageTitle': 'Privacy Policy',
  'legal.privacy.metaDescription': 'Learn how we collect, use, and protect your personal information',
  'legal.privacy.dataCollection.title': 'Data Collection',
  'legal.privacy.dataUsage.title': 'How We Use Your Data',
  'legal.privacy.dataSharing.title': 'Data Sharing',
  'legal.privacy.yourRights.title': 'Your Rights',
  'legal.privacy.security.title': 'Security Measures',
  'legal.privacy.retention.title': 'Data Retention',
  'legal.privacy.contact.title': 'Contact Information',
  'legal.privacy.changes.title': 'Policy Changes',
  // Detailed cookie descriptions for the cookies page
  'legal.cookies.categories.essential.detailedDescription': 'Essential cookies and local storage are strictly necessary for the website to function. We store authentication tokens via Supabase, and use localStorage for theme and language preferences. These cannot be disabled.',
  'legal.cookies.categories.essential.examples.auth': 'Authentication tokens (Supabase secure cookies)',
  'legal.cookies.categories.essential.examples.preferences': 'Theme and language preferences (localStorage)',
  'legal.cookies.categories.essential.examples.security': 'Security tokens and session management',
  'legal.cookies.categories.essential.examples.session': 'Session state and navigation history (sessionStorage)',
  'legal.cookies.categories.errorTracking.detailedDescription': 'Error tracking uses Sentry (only in production) to help us identify and fix bugs. We sample 10% of sessions and anonymize all personal data. No marketing or advertising data is collected.',
  'legal.cookies.categories.errorTracking.examples.monitoring': 'Error detection and crash reporting',
  'legal.cookies.categories.errorTracking.examples.debugging': 'Stack traces and debugging context (anonymized)',
  'legal.cookies.categories.errorTracking.examples.performance': 'Performance monitoring (10% sample rate)',
  'legal.cookies.categories.errorTracking.examples.privacy': 'All cookies, headers, and personal data removed before sending',
  'legal.cookies.control.title': 'How to Control Cookies',
  'legal.cookies.control.description': 'You have several options to manage and control cookies on our website and in your browser.',
  'legal.cookies.control.preferences': 'Use our cookie preference center to customize your settings',
  'legal.cookies.control.browser': 'Configure cookie settings directly in your browser',
  'legal.cookies.control.thirdParty': 'Manage third-party cookies through external services',
  'legal.cookies.control.optOut': 'Opt-out of specific cookie categories using industry tools',
  'legal.cookies.contact.title': 'Contact Us About Cookies',
  'legal.cookies.contact.description': 'If you have questions about our use of cookies, please contact us at',
  'legal.nav.contact': 'Contact',
  'legal.contact.general': 'General Contact',
  'legal.contact.address': 'Address',
  'legal.privacy.title': 'Privacy Policy',
  'legal.privacy.introduction.title': 'Introduction',
  'legal.privacy.introduction.content': 'This privacy policy explains how subvention360 collects, uses, and protects your personal information when you use our subsidy discovery platform.',
  'legal.privacy.dataCollection.personalData.title': 'Personal Information',
  'legal.privacy.dataCollection.personalData.name': 'Full name and contact information',
  'legal.privacy.dataCollection.personalData.email': 'Email address for communications',
  'legal.privacy.dataCollection.personalData.phone': 'Phone number for support and verification',
  'legal.privacy.dataCollection.personalData.address': 'Physical address and location data',
  'legal.privacy.dataCollection.businessData.title': 'Business Data',
  'legal.privacy.dataCollection.businessData.farmInfo': 'Company information (SIREN, activity code, location, size, sector)',
  'legal.privacy.dataCollection.businessData.documents': 'Uploaded documents and company certificates',
  'legal.privacy.dataCollection.businessData.applications': 'Tracked subsidies and saved searches',
  'legal.privacy.dataCollection.technicalData.title': 'Technical and Usage Data',
  'legal.privacy.dataCollection.technicalData.cookies': 'Browser cookies and tracking technologies',
  'legal.privacy.dataCollection.technicalData.analytics': 'Website usage statistics and performance data',
  'legal.privacy.dataCollection.technicalData.usage': 'Feature usage patterns and user interactions',
  'legal.privacy.dataUsage.subsidyMatching': 'Matching subsidies and grants to your company profile and eligibility criteria',
  'legal.privacy.dataUsage.applicationForms': 'Providing information about subsidy application requirements',
  'legal.privacy.dataUsage.communication': 'Sending notifications, updates, and customer support',
  'legal.privacy.dataUsage.improvement': 'Improving our services and developing new features',
  'legal.privacy.dataUsage.compliance': 'Meeting legal obligations and regulatory requirements',

  // Data Retention (COMP-002)
  'legal.privacy.dataRetention.title': 'Data Retention',
  'legal.privacy.dataRetention.intro': 'We retain your personal data only as long as necessary for the purposes outlined in this policy:',
  'legal.privacy.dataRetention.userAccounts.title': 'User Accounts',
  'legal.privacy.dataRetention.userAccounts.period': 'Deleted after 2 years of inactivity',
  'legal.privacy.dataRetention.applicationData.title': 'Application Data',
  'legal.privacy.dataRetention.applicationData.period': 'Deleted when you delete your account',
  'legal.privacy.dataRetention.auditLogs.title': 'Audit Logs',
  'legal.privacy.dataRetention.auditLogs.period': 'Anonymized after 7 years (French Commercial Code requirement)',
  'legal.privacy.dataRetention.paymentRecords.title': 'Payment Records',
  'legal.privacy.dataRetention.paymentRecords.period': 'Anonymized after 10 years (French tax compliance)',
  'legal.privacy.dataRetention.temporaryData.title': 'Temporary Data',
  'legal.privacy.dataRetention.temporaryData.period': 'Deleted after 90 days (processing artifacts, session logs)',
  'legal.privacy.dataRetention.deletionRequests.title': 'Account Deletion Requests',
  'legal.privacy.dataRetention.deletionRequests.period': 'Executed after a 30-day grace period',

  'legal.privacy.rights.title': 'Your Rights',
  'legal.privacy.rights.access.title': 'Right to Access',
  'legal.privacy.rights.access.description': 'Request a copy of all personal data we hold about you',
  'legal.privacy.rights.portability.title': 'Data Portability',
  'legal.privacy.rights.portability.description': 'Download your data in a structured, machine-readable format',
  'legal.privacy.rights.rectification.title': 'Right to Rectification',
  'legal.privacy.rights.rectification.description': 'Request correction of inaccurate or incomplete personal data',
  'legal.privacy.rights.deletion.title': 'Right to Erasure (Right to be Forgotten)',
  'legal.privacy.rights.deletion.description': 'Request deletion of your personal data under certain conditions',
  'legal.privacy.contact.description': 'For privacy-related questions or to exercise your rights, contact our Data Protection Officer at',


  // Terms of Service translations
  'legal.terms.pageTitle': 'Terms of Service',
  'legal.terms.metaDescription': 'Read our terms of service and user agreement for subvention360',
  'legal.terms.title': 'Terms of Service',
  'legal.terms.introduction.title': 'Introduction',
  'legal.terms.introduction.content': 'These terms govern your use of subvention360 and our services. By accessing or using our platform, you agree to be bound by these terms.',

  'legal.terms.services.title': 'Our Services',
  'legal.terms.services.description': 'subvention360 provides subsidy discovery and matching services for businesses using artificial intelligence:',
  'legal.terms.services.subsidySearch': 'AI-powered subsidy search and matching',
  'legal.terms.services.applicationAssistance': 'Opportunity tracking and deadline management',
  'legal.terms.services.documentManagement': 'Multi-client management for professionals',
  'legal.terms.services.userPortal': 'User portal and dashboard',

  'legal.terms.userObligations.title': 'User Obligations',
  'legal.terms.userObligations.accuracy': 'Provide accurate and complete information for all applications',
  'legal.terms.userObligations.compliance': 'Comply with all applicable laws and regulations',
  'legal.terms.userObligations.responsibility': 'Use the service responsibly and ethically',
  'legal.terms.userObligations.prohibited': 'Refrain from any prohibited or unlawful activities',

  'legal.terms.liability.title': 'Limitation of Liability',
  'legal.terms.liability.limitation': 'Our liability is limited as follows:',
  'legal.terms.liability.noWarranty': 'We do not guarantee the accuracy or completeness of subsidy information',
  'legal.terms.liability.indemnification': 'You agree to indemnify us against any claims arising from your use of our services',

  'legal.terms.modification.title': 'Modifications to Terms',
  'legal.terms.modification.content': 'We may update these terms from time to time. Continued use constitutes acceptance of modified terms.',

  'legal.terms.termination.title': 'Termination',
  'legal.terms.termination.content': 'Either party may terminate this agreement at any time with appropriate notice.',

  'legal.terms.governing.title': 'Governing Law',
  'legal.terms.governing.content': 'These terms are governed by the laws of the jurisdiction where our company is incorporated.',

  'legal.terms.contact.title': 'Contact Information',
  'legal.terms.contact.content': 'For questions about these terms, please contact us using the information below.',

  'legal.terms.effective.title': 'Effective Date',
  'legal.terms.effective.date': 'These terms are effective as of the date last updated above.',

  'legal.terms.service.title': 'Our Service',
  'legal.terms.service.description': 'subvention360 provides subsidy discovery and matching services for businesses using artificial intelligence:',
  'legal.terms.service.subsidySearch': 'Access to 144,000+ French and European subsidies',
  'legal.terms.service.documentExtraction': 'AI-powered document analysis and data extraction',
  'legal.terms.service.formCompletion': 'Automated form completion assistance',
  'legal.terms.service.applicationTracking': 'Application progress tracking and deadline management',
  'legal.terms.service.compliance': 'Regulatory compliance guidance and updates',

  'legal.terms.obligations.title': 'User Obligations',
  'legal.terms.obligations.accurateInfo': 'Provide accurate and complete information for all applications',
  'legal.terms.obligations.compliance': 'Comply with all applicable laws and regulations',
  'legal.terms.obligations.responsible': 'Use the service responsibly and ethically',
  'legal.terms.obligations.prohibited': 'Refrain from any prohibited or unlawful activities',
  'legal.terms.obligations.security': 'Maintain the security and confidentiality of your account',

  'legal.terms.ip.title': 'Intellectual Property',
  'legal.terms.ip.description': 'All content and technology on our platform is protected by intellectual property rights.',
  'legal.terms.ip.userContent.title': 'Your Content',
  'legal.terms.ip.userContent.description': 'You retain ownership of content you upload, but grant us license to use it for providing our services.',
  'legal.terms.ip.platformContent.title': 'Our Content',
  'legal.terms.ip.platformContent.description': 'All platform content, including software, databases, and documentation, remains our exclusive property.',

  'legal.terms.payment.title': 'Payment Terms',
  'legal.terms.payment.pricing.title': 'Pricing and Fees',
  'legal.terms.payment.pricing.description': 'Current pricing is available on our website and may be updated with notice.',
  'legal.terms.payment.billing.title': 'Billing and Payments',
  'legal.terms.payment.billing.description': 'Payments are processed securely through our payment partners. All fees are non-refundable unless required by law.',
  'legal.terms.payment.refunds.title': 'Refunds and Cancellations',
  'legal.terms.payment.refunds.description': 'You may cancel your subscription at any time. Refunds are provided according to our refund policy.',

  'legal.terms.law.title': 'Governing Law',
  'legal.terms.law.description': 'These terms are governed by the laws of the jurisdiction where our company is incorporated.',

  // Missing liability keys
  'legal.terms.liability.description': 'Our liability is limited to the maximum extent permitted by law.',
  'legal.terms.liability.noGuarantee': 'We provide our service "as is" without warranties or guarantees.',
  'legal.terms.liability.accuracy': 'While we strive for accuracy, we cannot guarantee the completeness or correctness of all information.',
  'legal.terms.liability.thirdParty': 'We are not responsible for third-party content or services.',
  'legal.terms.liability.damages': 'Our liability for damages is limited to the amount paid for our services.',

  // Missing termination keys
  'legal.terms.termination.user.title': 'User Termination',
  'legal.terms.termination.user.description': 'You may terminate your account at any time by contacting support or using account settings.',
  'legal.terms.termination.platform.title': 'Platform Termination',
  'legal.terms.termination.platform.description': 'We may terminate accounts that violate these terms or for other legitimate business reasons with appropriate notice.',

  // Navigation - additional
  'legal.nav.mentions': 'Legal Notice',
  'legal.nav.cgv': 'Terms of Sale',

  // Legal Notice (Mentions Légales)
  'legal.mentions.pageTitle': 'Legal Notice',
  'legal.mentions.metaDescription': 'Legal notice for subvention360 - Publisher and hosting information',
  'legal.mentions.title': 'Legal Notice',
  'legal.mentions.intro.title': 'Legal Information',
  'legal.mentions.intro.content': 'In accordance with the provisions of articles 6-III and 19 of Law No. 2004-575 of June 21, 2004 on Confidence in the Digital Economy (LCEN), we bring to the attention of users and visitors of the site the following information.',
  'legal.mentions.company.title': 'Site Publisher',
  'legal.mentions.company.name': 'Company Name',
  'legal.mentions.company.legalForm': 'Legal Form',
  'legal.mentions.company.siren': 'SIREN',
  'legal.mentions.company.siret': 'SIRET',
  'legal.mentions.company.vatNumber': 'VAT Number',
  'legal.mentions.company.rcs': 'Trade Register',
  'legal.mentions.company.capital': 'Share Capital',
  'legal.mentions.company.creationDate': 'Date of Incorporation',
  'legal.mentions.company.address': 'Registered Office',
  'legal.mentions.director.title': 'Publication Director',
  'legal.mentions.director.name': 'Name',
  'legal.mentions.director.role': 'Position',
  'legal.mentions.hosting.title': 'Hosting Provider',
  'legal.mentions.hosting.provider': 'Host',
  'legal.mentions.hosting.address': 'Address',
  'legal.mentions.hosting.website': 'Website',
  'legal.mentions.contact.title': 'Contact',
  'legal.mentions.contact.email': 'Email',
  'legal.mentions.contact.website': 'Website',
  'legal.mentions.ip.title': 'Intellectual Property',
  'legal.mentions.ip.content': 'This entire website is subject to French and international legislation on copyright and intellectual property. All reproduction rights are reserved, including for downloadable documents and iconographic and photographic representations. Reproduction of all or part of this site on any electronic medium is strictly prohibited without express authorization from the publication director.',

  // Terms of Sale (CGV)
  'legal.cgv.pageTitle': 'Terms of Sale',
  'legal.cgv.metaDescription': 'Terms of sale for subvention360 - Subscription and payment terms',
  'legal.cgv.title': 'Terms of Sale',
  'legal.cgv.intro.title': 'Preamble',
  'legal.cgv.intro.content': 'These Terms of Sale govern the contractual relationship between ECOEMIT SOLUTIONS and its customers for the use of services offered on the subvention360.com platform. Any subscription to our services implies unreserved acceptance of these Terms of Sale.',
  'legal.cgv.intro.vendor': 'Seller',
  'legal.cgv.intro.address': 'Address',
  'legal.cgv.services.title': 'Services Offered',
  'legal.cgv.services.description': 'subvention360 is an information and matching platform that uses artificial intelligence to help you discover subsidies and grants that match your profile. The platform offers:',
  'legal.cgv.services.search': 'Access to a database of over 144,000 French and European subsidies and grants',
  'legal.cgv.services.matching': 'AI-powered intelligent matching with your company profile',
  'legal.cgv.services.tracking': 'Dashboard for tracking your opportunities and deadlines',
  'legal.cgv.services.alerts': 'Automatic alerts on new opportunities matching your profile',
  'legal.cgv.services.multiClient': 'Multi-client management for professionals (accountants, consultants)',
  'legal.cgv.services.support': 'Assistance and customer support',
  'legal.cgv.services.disclaimer': 'Important: subvention360 is an information and search service. We do not submit subsidy applications on your behalf and do not guarantee that identified subsidies will be obtained.',
  'legal.cgv.pricing.title': 'Pricing and Payment',
  'legal.cgv.pricing.plans.title': 'Subscription Plans',
  'legal.cgv.pricing.plans.description': 'Current prices are displayed on our Pricing page. We offer different plans adapted to the needs of businesses, consultants, and individuals.',
  'legal.cgv.pricing.currency.title': 'Currency',
  'legal.cgv.pricing.currency.description': 'All prices are expressed in euros (EUR).',
  'legal.cgv.pricing.vat.title': 'VAT',
  'legal.cgv.pricing.vat.description': 'Displayed prices are exclusive of tax (HT). French VAT at the current rate (20%) will be applied for customers established in France. For professional customers in the European Union with a valid intra-community VAT number, VAT will not be charged (reverse charge).',
  'legal.cgv.pricing.payment.title': 'Payment Methods',
  'legal.cgv.pricing.payment.description': 'Payment is made by credit card through our secure payment provider Stripe. Visa, Mastercard, and American Express cards are accepted.',
  'legal.cgv.subscription.title': 'Subscription',
  'legal.cgv.subscription.duration.title': 'Duration',
  'legal.cgv.subscription.duration.description': 'Subscriptions are taken out for a monthly or annual period depending on the chosen plan. The subscription takes effect on the date of payment validation.',
  'legal.cgv.subscription.renewal.title': 'Renewal',
  'legal.cgv.subscription.renewal.description': 'The subscription is automatically renewed for an identical period to the initial term, unless terminated by either party.',
  'legal.cgv.subscription.cancellation.title': 'Cancellation',
  'legal.cgv.subscription.cancellation.description': 'You can cancel your subscription at any time from your account settings. The cancellation will take effect at the end of the current subscription period. No pro-rata refund will be made for the remaining period.',
  'legal.cgv.withdrawal.title': 'Right of Withdrawal',
  'legal.cgv.withdrawal.description': 'In accordance with Article L221-18 of the French Consumer Code, you have a right of withdrawal.',
  'legal.cgv.withdrawal.period.title': 'Withdrawal Period',
  'legal.cgv.withdrawal.period.description': 'You have 14 days from the subscription date to exercise your right of withdrawal, without having to justify any reason or pay any penalty.',
  'legal.cgv.withdrawal.howTo.title': 'How to Exercise This Right',
  'legal.cgv.withdrawal.howTo.description': 'To exercise your right of withdrawal, you must notify us of your decision by email to contact@subvention360.com or by mail to our postal address, clearly stating your wish to withdraw.',
  'legal.cgv.withdrawal.refund.title': 'Refund',
  'legal.cgv.withdrawal.refund.description': 'In case of withdrawal, we will refund all payments received within a maximum of 14 days from receipt of your request, using the same payment method used for the initial transaction.',
  'legal.cgv.liability.title': 'Liability',
  'legal.cgv.liability.description': 'ECOEMIT SOLUTIONS is committed to providing a quality service. However, our liability is limited in the following cases:',
  'legal.cgv.liability.accuracy': 'Information about subsidies is provided for informational purposes and may change',
  'legal.cgv.liability.availability': 'We do not guarantee uninterrupted service availability',
  'legal.cgv.liability.thirdParty': 'We are not responsible for decisions made by funding organizations',
  'legal.cgv.liability.decisions': 'Obtaining a subsidy depends on criteria specific to each organization',
  'legal.cgv.law.title': 'Applicable Law',
  'legal.cgv.law.description': 'These Terms of Sale are governed by French law. Any dispute relating to their interpretation or execution falls under the jurisdiction of the French courts.',
  'legal.cgv.law.disputes.title': 'Dispute Resolution',
  'legal.cgv.law.disputes.description': 'In case of dispute, we invite you to contact us first to try to find an amicable solution.',
  'legal.cgv.law.mediation.title': 'Mediation',
  'legal.cgv.law.mediation.description': 'In accordance with articles L.616-1 and R.616-1 of the French Consumer Code, you can use the consumer mediation service free of charge. The mediator will be appointed after referral.',
  'legal.cgv.contact.title': 'Contact',
  'legal.cgv.contact.description': 'For any questions regarding these Terms of Sale or your subscription, you can contact us:',
  'legal.cgv.contact.sales': 'Sales Department',
  'legal.cgv.contact.support': 'Customer Support',
  'legal.cgv.contact.address': 'Address'
} as const;